// @flow
import React, { Component, type Node } from 'react';
import './Partnerpone.scss';

type Props = {
  duration?: number,
  children: Node,
};

type State = {
  visible: boolean,
};

class Partnerpone extends Component<Props, State> {
  static defaultProps = {
    duration: 200,
  };
  timeoutId = null;
  state = {
    visible: false,
  };

  componentDidMount() {
    const { duration } = this.props;
    this.timeoutId = setTimeout(() => {
      this.setState({
        visible: true,
      });
    }, duration);
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    if (!this.state.visible) return null;
    return this.props.children;
  }
}

export default Partnerpone;



// WEBPACK FOOTER //
// ./src/components/common/Partnerpone/Partnerpone.js